import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BlogServiceService } from 'src/app/admin/services/blog/blog-service.service';
import { GuidanceService } from 'src/app/admin/services/guidance/guidance.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
    selector: 'app-add-guidance-category',
    templateUrl: './add-guidance-category.component.html',
    styleUrls: ['./add-guidance-category.component.scss'],
    standalone: false
})
export class AddGuidanceCategoryComponent implements OnInit {
  
  constructor(
    private userdata: UserdataService,
    private toast: ToastrService,
    private guidanceService: GuidanceService,
    private route: Router,
    private spinner: NgxSpinnerService
  ) { }


  formGroup: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl('', Validators.required),
    guidanceCategory_image: new UntypedFormControl('', Validators.required),
  });

  ngOnInit(): void {
    this.formGroup.patchValue({ userId: this.userdata.getId() })
    this.formGroup.patchValue({ addedBy: this.userdata.getName() })
  }

  get f() {
    return this.formGroup.controls
  }

  uploadImage(event: any) {
    this.formGroup.patchValue({ 'guidanceCategory_image': event.target.files[0] });
  }

  submit() {
    this.spinner.show()
    let data = new FormData();
    data.append('name', this.formGroup.value.name ?? '');
    data.append('guidanceCategory_image', this.formGroup.value.guidanceCategory_image ?? '');
    this.guidanceService.addGuidanceCategory(data).subscribe(
      (res: any) => {
        if (res.success) {
          this.spinner.hide()
          this.toast.success(res.message, 'Success')
          this.route.navigateByUrl('/admin/guidance-category/list')
        }
        else {
          this.spinner.hide()
          this.toast.error(res.message)
        }
      }, err => {
        this.spinner.hide()
        this.toast.error(err.error.message, 'Error')
      }
    )
  }



}
